import React, { useEffect, useState } from 'react';
import { Drawer, IconButton } from '@material-ui/core';
import { Close } from '@material-ui/icons';
import { Container, Header, Body, Row } from './DeliveryActivity.styled';
import InputSearch from '../OpenActivity/OpenActivityTable/InputSearch';
import { Wrapper } from '../ClickActivity/ClickActivity.styled';
import ABToggleButton from '../ClickActivity/ABToggleButton';
import ExportBtn from '../DeliveryActivity/ExportBtn';
import DeliveryActivityTable from './DeliveryActivityTable/DeliveryActivityTable';
import { fetchDeliveryEventsData, mapDeliveryRows } from './api';

const DeliveryActivity = ({
  isDeliveryActivityDrawerVisible,
  setDeliveryActivityVisibility,
  initialMessage,
  orgId,
  channel,
}) => {
  const [message, setMessage] = useState({});
  const [rows, setRows] = useState([]);
  const [isLoading, setLoading] = useState(true);

  useEffect(() => {
    if (initialMessage) {
      setMessage(initialMessage);
    }
  }, [initialMessage]);

  const getVersionName = message => {
    if (!message?.AB || !message.AB.version) return '';

    return `(Version ${message.AB.version})`;
  };

  const closeDrawer = () => {
    setDeliveryActivityVisibility(false);
  };

  const getDeliveryActivityTableRows = async ({ messageId, orgId, search }) => {
    const data = await fetchDeliveryEventsData({
      messageId,
      orgId,
      channel,
      ...search,
    });
    return mapDeliveryRows(data?.deliveryTableData);
  };

  return (
    <Drawer
      open={isDeliveryActivityDrawerVisible}
      onClose={closeDrawer}
      anchor="right"
    >
      <Container>
        <Header>
          <IconButton size={'small'} style={{ color: 'white' }}>
            <Close size={'small'} onClick={closeDrawer} />
          </IconButton>
          Delivery Activity: {message?.draftName} {getVersionName(message)}
        </Header>
        <Body>
          <Row>
            <InputSearch
              messageId={message.id}
              setLoading={setLoading}
              setRows={setRows}
              orgId={orgId}
              getTableRowData={getDeliveryActivityTableRows}
            />
            <Wrapper>
              {message?.AB && message?.AB.version && (
                <ABToggleButton message={message} setMessage={setMessage} />
              )}
              <ExportBtn tableRowData={rows} message={message} />
            </Wrapper>
          </Row>
          <DeliveryActivityTable
            isLoading={isLoading}
            setLoading={setLoading}
            messageId={message.id}
            rows={rows}
            setRows={setRows}
            orgId={orgId}
            channel={channel}
          />
        </Body>
      </Container>
    </Drawer>
  );
};

export default DeliveryActivity;
